import {
    customStylesSelect,
    dropdownWorkfromHomeList,
    dropdownWfhsiftList,
  } from "common/data/settings"
  import React, { Fragment, useEffect, useState } from "react"
  import DatePicker from "react-datepicker"
  import Select from "react-select"
  import { Col, Collapse, Row, Form } from "reactstrap"
  
  const Filter = props => {
    const { handleSubmit, setExpandedRow, setSelectname, selectname, allUserLists } = props
 
  
    const startDateChange = date => {
      setExpandedRow(null)
      props.setStartDate(date)
    }
    const endDateChange = date => {
      setExpandedRow(null)
      props.setEndDate(date)
    }

    return (
      <Fragment>
        <Row>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-2 mobile_responsive_user">
              <Col lg={2} className=" justify-content-start">
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  selected={props.startDate}
                  onChange={startDateChange}
                  className="form-control mb-2 date-icon-back"
                  placeholderText="Select date"
                  maxDate={new Date()}
                />
              </Col>
              <Col lg={2} className=" justify-content-start">
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  selected={props.endDate}
                  onChange={endDateChange}
                  className="form-control mb-2 date-icon-back"
                  placeholderText="Select date"
                  minDate={new Date(props.startDate)}
                />
              </Col>
              <Col lg={2} className=" justify-content-start">
                <Select
                  className="mb-2"
                  value={props.activeUser}
                  onChange={value => props.handleActiveUser(value)}
                  options={allUserLists}
                  classNamePrefix="select2-selection"
                  placeholder="Select Workfrom home"
                  styles={customStylesSelect}
                />
              </Col>             
              <Col lg={2} className=" justify-content-start">
                <Select
                  className="mb-2"
                  value={props.activeShift}
                  onChange={value => props.handleActiveShift(value)}
                  options={dropdownWfhsiftList}
                  classNamePrefix="select2-selection"
                  placeholder="Select Shift"
                  styles={customStylesSelect}
                />
              </Col>
              <Col lg={2} className=" justify-content-start">
                <Select
                  className="mb-2"
                  value={props.activeworkfromhome}
                  onChange={value => props.handleactiveworkfromhome(value)}
                  options={dropdownWorkfromHomeList}
                  classNamePrefix="select2-selection"
                  placeholder="Select Employee"
                  styles={customStylesSelect}
                />
              </Col>
              <Col lg={1}>
                <div className="d-flex mobile_responsive_user">
                  <button
                    className="btn btn-primary mb-2 me-2"
                    type="submit"
                    onClick={handleSubmit}
                    style={{ width: "100%" }}
                  >
                    <i className="bx bx-filter-alt align-middle"></i> Filter
                  </button>
                </div>
                </Col>
                <Col lg={1}>
                  <button
                    onClick={e => props.ExportDetailedWorkFromHomeReport(e)}
                    className="btn btn-primary mb-2"
                    style={{ width: "100%" }}
                    >
                    <i className="bx bx-download align-middle"></i> Export
                    </button>
                  </Col>
            </Row>
          </Form>
        </Row>
      </Fragment>
    )
  }
  
  export default Filter
  